module.exports = __webpack_public_path__ + "static/media/register.a88abe9f.jpg";